/* tslint:disable */
/* eslint-disable */
/**
 * Melco Efs APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    EfsMelcoModelsThreadColor,
    EfsMelcoModelsThreadColorFromJSON,
    EfsMelcoModelsThreadColorFromJSONTyped,
    EfsMelcoModelsThreadColorToJSON,
} from './';

/**
 * 
 * @export
 * @interface EfsMelcoModelsColorListItem
 */
export interface EfsMelcoModelsColorListItem {
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    code?: string | null;
    /**
     * 
     * @type {EfsMelcoModelsThreadColor}
     * @memberof EfsMelcoModelsColorListItem
     */
    color?: EfsMelcoModelsThreadColor;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    type?: string | null;
    /**
     * 
     * @type {number}
     * @memberof EfsMelcoModelsColorListItem
     */
    weight?: number;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    supplier_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof EfsMelcoModelsColorListItem
     */
    product_name?: string | null;
}

export function EfsMelcoModelsColorListItemFromJSON(json: any): EfsMelcoModelsColorListItem {
    return EfsMelcoModelsColorListItemFromJSONTyped(json, false);
}

export function EfsMelcoModelsColorListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): EfsMelcoModelsColorListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'code': !exists(json, 'code') ? undefined : json['code'],
        'color': !exists(json, 'color') ? undefined : EfsMelcoModelsThreadColorFromJSON(json['color']),
        'type': !exists(json, 'type') ? undefined : json['type'],
        'weight': !exists(json, 'weight') ? undefined : json['weight'],
        'supplier_name': !exists(json, 'supplier_name') ? undefined : json['supplier_name'],
        'product_name': !exists(json, 'product_name') ? undefined : json['product_name'],
    };
}

export function EfsMelcoModelsColorListItemToJSON(value?: EfsMelcoModelsColorListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'code': value.code,
        'color': EfsMelcoModelsThreadColorToJSON(value.color),
        'type': value.type,
        'weight': value.weight,
        'supplier_name': value.supplier_name,
        'product_name': value.product_name,
    };
}


